/**
 * CounterPriceUnit - synchronized with the Prisma enum of the same name.
 * Lives on `MenuItem.priceUnit` (out of this agent's scope), not on
 * `CounterLabelData` — price and its unit never invalidate a confirmation.
 */
export const COUNTER_PRICE_UNITS = ['KG', 'LITRE', 'PIECE'] as const;
export type CounterPriceUnit = (typeof COUNTER_PRICE_UNITS)[number];
